export const AxesColorRedLetter = '#c20017';
export const AxesColorGreenLetter = '#00ab26';
export const AxesColorBlueLetter = '#0081d4';

export const AxesColorRed = AxesColorRedLetter;
export const AxesColorGreen = AxesColorGreenLetter;
export const AxesColorBlue = AxesColorBlueLetter;
